import axios from 'axios';
import { defineStore } from 'pinia';
import { authStore } from '../stores/auth';

export const dashboardStore = defineStore('dashboard-store', {
    state: () => {
        return {
            dashboardData: '',
            invoices: [],
        };
    },

    getters: {
        dashboard(state) {
            return state.dashboardData;
        },
        invoices(state) {
            const invoices = state.dashboardData?.invoices ?? [];

            const normalizedInvoices = invoices.map((inv) => ({
                id: inv.id ?? inv.invoiceId,
                invoiceNumber: inv.invoiceId,
                expireDate: inv.expirationDate ? inv.expirationDate.split('T')[0] : null,
                amountToPay: inv.amount,
                status: inv.paymentStatus === 1 ? 'betald' : 'obetald',
                uid: window.btoa(`${inv.invoiceId}:${inv.transactionTypeName}`),
            }));

            const sorted = normalizedInvoices.sort((a, b) =>
                new Date(a.expireDate || 0).getTime() > new Date(b.expireDate || 0).getTime() ? -1 : 1
            );

            return sorted.slice(0, 3);
        },
        cleanedQueues(state) {
            //Remove all queues with 0 points
            let filteredQueues = state.dashboardData.vacancy.queues.filter((queue) => queue.points >= 0);
            //Quickfix for dispaly names
            filteredQueues.forEach((queue) => {
                if (queue.displayname === 'Bilplats') {
                    queue.displayname = queue.displayname + 'kö';
                }
                if (queue.displayname === 'Förråd') {
                    queue.displayname = queue.displayname + 'skö';
                }
            });

            //If 'bostad' remains set that as the primary queue otherwise use the first avalible
            let primaryIndex = filteredQueues.findIndex((queue) => queue.name === 'Bostad');
            primaryIndex = primaryIndex > 0 ? primaryIndex : 0;
            let primaryQueue = filteredQueues.splice(primaryIndex, 1)[0];
            //Retur the rest as 'others'
            let otherQueues = filteredQueues;
            //Return the output
            return {
                primaryQueue: primaryQueue,
                otherQueues: otherQueues,
            };
        },
    },

    actions: {
        async fetchDashboardData() {
            const response = await axios.get(process.env.VUE_APP_API_BASE_URL + 'dashboard/me', authStore().authConfig);
            try {
                this.dashboardData = response.data;
            } catch (err) {
                this.dashboardData = '';
                console.error('Error loading dashboardData:', err);
                return err;
            }
        },
    },
});
